import { LoadingAppCard } from "./LoadingAppCard";

export const LoadingGalleryOrganizationApps = () => {
  return (
    <div className="mt-2 grid grid-cols-1 lg:grid-cols-2 gap-3">
      <LoadingAppCard />
      <LoadingAppCard />
      <LoadingAppCard />
    </div>
  );
};
